import { languageOptions } from "../language-options";

export function getLang(language: string) {
  return Object.keys(languageOptions).find((l) =>
    language.startsWith(l)
  ) as keyof typeof languageOptions;
}
